import { Pipe, PipeTransform } from '@angular/core';
import { FileIcons, getFontAwesomeIcon, getMaximizerIcon } from '../icons';
import { isDoc, isImage, isPdf, isPpt, isXls } from '@maximizer/shared/util';
@Pipe({ name: 'fileIcon', })
export class FileIconPipe implements PipeTransform {
  transform(name: string): string {
    let icon = getMaximizerIcon('document-uploaded');

    if (isDoc(name)) {
      icon = getFontAwesomeIcon(FileIcons.doc);
    } else if (isPdf(name)) {
      icon = getFontAwesomeIcon(FileIcons.pdf);
    } else if (isPpt(name)) {
      icon = getFontAwesomeIcon(FileIcons.ppt);
    } else if (isXls(name)) {
      icon = getFontAwesomeIcon(FileIcons.xls);
    } else if (isImage(name)) {
      icon = getFontAwesomeIcon(FileIcons.image);
    }

    return icon;
  }
}
